var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemasterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 19,
    viewBox: "0 0 370 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1674_14483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22999 11.1838H2.58403V18.9957H0V0H9.12658C14.1382 0 15.538 2.8914 15.538 5.59404C15.538 7.70896 14.4046 10.1413 11.0805 10.8406L16.1978 19H13.1655L8.23422 11.1881L8.22999 11.1838ZM2.58403 9.01739H8.75864C11.8459 9.01739 12.8229 7.35719 12.8229 5.56401C12.8229 3.77083 11.8459 2.19214 8.78824 2.19214H2.58403V9.01739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0898 0H50.913L56.9523 14.7187C57.2441 15.4694 57.3752 15.7869 57.481 16.3789H57.5317C57.6628 15.7911 57.7939 15.4694 58.0603 14.7187L64.1842 0H68.037V18.9957H65.6644V4.14834C65.6644 3.42764 65.6644 2.70264 65.7448 2.22217H65.639C65.5333 2.54391 65.2711 3.50485 64.9793 4.14834L58.7539 19H56.246L50.046 4.1226C49.8092 3.56062 49.5724 2.62542 49.492 2.22217H49.3609C49.4117 2.70264 49.4666 3.32039 49.4666 4.14834V18.9957H47.0941V0H47.0898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2552 14.0752H76.1517L74.0667 19H71.3516L79.8987 0H82.5082L91.0553 19H88.3106L86.251 14.0752H86.2552ZM85.3332 11.883L82.5378 5.24656C81.9034 4.04109 81.5354 3.32039 81.2182 2.30368H81.1675C80.8503 3.32039 80.5077 4.04109 79.8734 5.24656L77.0779 11.883H85.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9102 13.0405L94.4325 12.61C95.033 15.1929 96.9548 16.9433 100.702 16.9433C103.625 16.9433 105.623 16.0579 105.623 13.804C105.623 11.7775 104.326 11.018 101.751 10.6363L97.8557 10.1042C94.6847 9.62096 92.787 8.2036 92.787 5.16583C92.787 1.97374 95.4855 0 100.054 0C104.622 0 107.296 1.69758 108.069 5.26736L105.623 5.87654C104.998 3.34236 103.301 2.00217 99.9776 2.00217C97.0789 2.00217 95.3093 3.0662 95.3093 4.96684C95.3093 6.74158 96.3062 7.57412 98.8286 7.95587L102.624 8.51225C106.119 9.04427 108.169 10.3885 108.169 13.5766C108.169 16.7646 105.723 18.9982 100.654 18.9982C95.5856 18.9982 92.6388 16.7443 91.9142 13.0445L91.9102 13.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.601 2.21788H119.454V18.9957H116.87V2.21788H109.723V0H126.606V2.21788H126.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.041 16.8036V18.9957H129.691V0H143.859V2.19214H132.28V8.1594H143.411V10.3515H132.28V16.7993H144.045L144.041 16.8036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.988 11.1838H151.342V18.9957H148.758V0H157.884C162.896 0 164.296 2.8914 164.296 5.59404C164.296 7.70896 163.162 10.1413 159.838 10.8406L164.956 19H161.923L156.992 11.1881L156.988 11.1838ZM151.342 9.01739H157.516C160.604 9.01739 161.581 7.35719 161.581 5.56401C161.581 3.77083 160.604 2.19214 157.546 2.19214H151.346V9.01739H151.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6389 0H20.2031V2.21788H42.6389V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6389 16.7812H20.2031V18.9991H42.6389V16.7812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6389 8.39014H20.2031V10.608H42.6389V8.39014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1674_14483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemasterLogo);
export default __webpack_public_path__ + "static/media/RemasterLogo.eb45e991d4de8d316fff2025ca818777.svg";
export { ForwardRef as ReactComponent };